import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { Button } from '../Button';
import Stack from '@mui/material/Stack';

export const FilterRow = styled('div')`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const FilterGroup = styled('div')`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;

  @media (max-width: 600px) {
    width: 100%;
  }
`;

export const SearchAndFilterStack = styled(Stack)`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 18px;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const SearchRow = styled('div')`
  display: flex;
  gap: 12px;
  width: 100%;
  align-items: center;
  padding: 4px;
  border-radius: 12px;

  @media (max-width: 600px) {
    flex-direction: column;
    background: ${({ theme }) =>
      theme.palette.mode === 'dark'
        ? theme.palette.transparent.tertiary
        : theme.palette.transparent.quaternary};
  }
`;

export const FilterActionsBox = styled(Box)`
  display: flex;
  gap: 16px;
  align-self: auto;
  width: 100%;
  justify-content: flex-end;
`;

export const FilterActionButton = styled(Button)`
  text-transform: none;
  height: 42px;
  border: ${({ theme }) =>
    theme.palette.mode === 'light'
      ? `1px solid ${theme.palette.primary.main}`
      : 'none'};
`;
